export const helpCharm_ariaLabel = "wssP4c";
export default {helpCharm_ariaLabel};